import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import CurrencyToggle from "./CurrencyToggle";

export default function DashboardHeader({ title, breadcrumb }) {
  return (
    <header className="sticky top-0 z-30 glass-nav border-b border-border">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <Link to="/dashboard" className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground shrink-0" data-testid="back-to-dashboard">
            <ArrowLeft className="w-4 h-4" /> <span className="hidden sm:inline">Dashboard</span>
          </Link>
          {title && (
            <>
              <span className="text-muted-foreground/50">/</span>
              <span className="font-display text-base sm:text-lg truncate">{title}</span>
            </>
          )}
        </div>
        <div className="flex items-center gap-2">
          <CurrencyToggle />
          <Link to="/dashboard" className="hidden sm:flex items-center gap-1">
            <span className="font-display text-xl">Ladybeauty</span>
            <Sparkles className="w-4 h-4 text-[hsl(var(--accent))]" />
          </Link>
        </div>
      </div>
    </header>
  );
}
